import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {toTitleCase} from 'common/util/string';
import {Tooltip} from 'common/components/tooltip';
import {IconSizeType} from 'common/constants';

import {UserListAttrs} from './types';
import {template} from './template';
import css from './index.styl?inline';

function deriveName(user) {
  if (user.email) {
    const [name] = user.email.split(`@`);
    return toTitleCase(name.replace(/[.\-_]/g, ` `));
  }
  return `Unknown User`;
}

export class UserList extends Component<EmptyObj, UserListAttrs> {
  static get attrsSchema(): AttrsSchema<UserListAttrs> {
    return {
      ...super.attrsSchema,
      users: {
        type: `json`,
        tsType: `UserItem[]`,
      },
      clickable: {type: `boolean`, description: `Have the component emit click events and apply basic hover styles`},
      'disable-tooltip': `boolean`,
      'tooltip-placement': Tooltip.attrsSchema[`placement`],
      'more-text': {
        type: `string`,
        description: `Text to display after count when the number of items is greater than 'show-max'`,
        default: `more`,
      },
      'user-count-override': {
        type: `number`,
        description: `Overrides the count after more - text`,
        default: null,
      },
      'show-max': {
        type: `number`,
        default: 7,
        description: `Maximum number of icons to show before replacing with the truncated text`,
      },
      size: {
        type: `string`,
        enum: Object.values(IconSizeType),
        default: IconSizeType.Medium,
      },
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      defaultState: {},
      helpers: {
        handleUserIconClick: (user) => this.dispatchEvent(new CustomEvent(`userClick`, {detail: {user}})),

        handleMoreTextClick: () => this.dispatchEvent(new CustomEvent(`moreTextClick`)),

        getName: (user) => user.name || deriveName(user),
      },
    };
  }
}

export const UserListEl = defineAndMakeJsxFactory(`mp-user-list`, UserList);
